import { Component, Input, OnInit } from '@angular/core';
import { BaseFormComponent } from '@shared/components/forms/base-form.component';
import { Project } from '@shared/models/project.model';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss'],
})
export class ContactFormComponent extends BaseFormComponent implements OnInit {
  @Input() ukrainianEvent: boolean;
  @Input() project: Project;
  constructor() {
    super();
  }

  ngOnInit() {
    this.addRecaptchaScript('email-send');
  }
}
